import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/app/Primitives";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ShiftDefinitions from "@/components/app/shifts/ShiftDefinitions";
import ShiftAssignments from "@/components/app/shifts/ShiftAssignments";
import ShiftRoster from "@/components/app/shifts/ShiftRoster";
import ShiftGroups from "@/components/app/shifts/ShiftGroups";
import ShiftRotations from "@/components/app/shifts/ShiftRotations";

export default function Shifts() {
    const [shifts, setShifts] = useState([]);

    const reload = useCallback(() => {
        api.get("/shifts").then((r) => setShifts(r.data.items || [])).catch(() => setShifts([]));
    }, []);
    useEffect(() => { reload(); }, [reload]);

    return (
        <>
            <PageHeader title="Shifts"
                subtitle="Define a shift once, then assign it to people, groups, departments, branches, positions, employment types or a whole company." />
            <Tabs defaultValue="definitions">
                <TabsList>
                    <TabsTrigger value="definitions" data-testid="tab-definitions">Definitions</TabsTrigger>
                    <TabsTrigger value="assignments" data-testid="tab-assignments">Assignments</TabsTrigger>
                    <TabsTrigger value="roster" data-testid="tab-roster">Roster</TabsTrigger>
                    <TabsTrigger value="groups" data-testid="tab-groups">Groups</TabsTrigger>
                    <TabsTrigger value="rotations" data-testid="tab-rotations">Rotations</TabsTrigger>
                </TabsList>
                <TabsContent value="definitions"><ShiftDefinitions shifts={shifts} reload={reload} /></TabsContent>
                <TabsContent value="assignments"><ShiftAssignments shifts={shifts} reload={reload} /></TabsContent>
                <TabsContent value="roster"><ShiftRoster /></TabsContent>
                <TabsContent value="groups"><ShiftGroups /></TabsContent>
                <TabsContent value="rotations"><ShiftRotations shifts={shifts} /></TabsContent>
            </Tabs>
        </>
    );
}
